export function AttributionFooter() {
  return (
    <footer className="py-2 text-center text-xs text-[#ECECEC]">
      <a
        href="https://www.flaticon.com/free-icons/spade"
        title="spade icons"
        target="_blank"
        rel="noreferrer"
        className="hover:underline underline-offset-2"
      >
        Spade icons created by Md Tanvirul Haque - Flaticon
      </a>
    </footer>
  );
}
